import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormularioDistribuidor from "./FormularioDistribuidor";
import { atualizarDistribuidor, obterDistribuidor } from "../services/api";

const EditarDistribuidor = ({ token }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    obterDistribuidor(id, token)
      .then((r) => setInitialData(r.data?.distribuidor || r.data))
      .catch(() => alert("Erro ao carregar distribuidor."));
  }, [id, token]);

  const handleSubmit = async (data) => {
    await atualizarDistribuidor(id, data, token);
    alert("Distribuidor atualizado com sucesso!");
    navigate("/distribuidores");
  };

  if (!initialData) return <div className="p-6">Carregando...</div>;

  return (
    <FormularioDistribuidor
      token={token}
      initialData={initialData}
      isEdit
      onSubmit={handleSubmit}
    />
  );
};

export default EditarDistribuidor;
